import { Component, inject } from '@angular/core';
import { CardComponent, ButtonComponent } from '@echospaces-web-monorepo/es-shared-ui';
import { AuthService } from '@echospaces-web-monorepo/es-auth';
import { Router } from '@angular/router';

@Component({
  selector: 'es-dashboard',
  imports: [CardComponent, ButtonComponent],
  template: `
    <div class="max-w-6xl mx-auto">
      <div class="mb-8">
        <h1 class="text-3xl font-bold text-gradient-brand font-exo">
          Willkommen{{ auth.user()?.firstName ? ', ' + auth.user()?.firstName : '' }}
        </h1>
        <p class="text-[var(--text-secondary)] mt-1">EchoSpaces Admin Portal</p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <es-card [clickable]="true" (clicked)="router.navigate(['/islands'])">
          <div class="flex items-center gap-4">
            <span class="text-3xl">🏝</span>
            <div>
              <h3 class="text-lg font-semibold">Islands</h3>
              <p class="text-sm text-[var(--text-secondary)]">Manage your virtual worlds</p>
            </div>
          </div>
        </es-card>

        <es-card [clickable]="true" (clicked)="router.navigate(['/content'])">
          <div class="flex items-center gap-4">
            <span class="text-3xl">📦</span>
            <div>
              <h3 class="text-lg font-semibold">Content</h3>
              <p class="text-sm text-[var(--text-secondary)]">Images, videos, 3D models</p>
            </div>
          </div>
        </es-card>

        <es-card [clickable]="true" (clicked)="router.navigate(['/users'])">
          <div class="flex items-center gap-4">
            <span class="text-3xl">👥</span>
            <div>
              <h3 class="text-lg font-semibold">Users</h3>
              <p class="text-sm text-[var(--text-secondary)]">Team members & permissions</p>
            </div>
          </div>
        </es-card>
      </div>
    </div>
  `,
})
export class DashboardComponent {
  auth = inject(AuthService);
  router = inject(Router);
}
